import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { Batch } from 'src/app/models';
import { ProductsAddComponent } from '../../products-operative-products/products-add/products-add.component';

@Component({
    selector: 'app-products-batch-add',
    templateUrl: './products-batch-add.component.html',
    styleUrl: './products-batch-add.component.sass',
    standalone: false
})
export class ProductsBatchAddComponent extends GenericCrudAddComponent<Batch>  {

  products? = this.api.resources.product.products;
  productBatchStates? = this.api.resources.product.productBatchStates;
  override resource = this.api.resources.product.batch;
  createProduct = ProductsAddComponent;


  override initFormGroup(): FormGroup<any> {
    const group = this.fb.group({
      productId: [],
      batch: [],
      providerBatch:[],
      expirationDate: [],
      productBatchStateId: [],
      barcode: [],
    });
    return group;
  }

  protected override async mapFormEntity(): Promise<Partial<Batch>> {
    if (!this.form) return {};

    const formValues = this.form.value;
  
    // Filter out undefined values
    const definedValues: Partial<Batch> = Object.keys(formValues).reduce((acc, key) => {
      const typedKey = key as keyof Batch;
      if (formValues[typedKey] !== null) {
        acc[typedKey] = formValues[typedKey];
      }
      return acc;
    }, {} as Partial<Batch>);
  
    // Create the batch object using Object.assign
    const batch: Partial<Batch> = Object.assign({}, definedValues);

    return batch;
  }
}
